import React from 'react';
import { Link } from 'react-scroll';


const Hero = () => {
  return (
    
      <div className="hero" style={{ backgroundImage: "url('images/3house.jpg')" , backgroundSize: ''}} >

        <div className="content">
          <h2>Find Your Dream Property with Us</h2>
          <p>Explore the best properties in the bubbling Sagamu-Ikenne Corridor.</p>
        </div>

        <Link
          to="contact"
          smooth={true}
          duration={800}>

          <button>Book a Tour</button>
        </Link>
      </div>
  );
};

export default Hero;
